import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/lib/theme';

function Toaster(props: ToasterProps) {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      richColors
      closeButton
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          // Contraste AA no tema claro (as cores "ricas" padrão ficam abaixo de 4,5:1).
          ...(resolved === 'light'
            ? { '--success-text': '#14532d', '--error-text': '#7f1d1d', '--warning-text': '#713f12', '--info-text': '#1e3a8a' }
            : {}),
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
